import variance from "./variance";

export default function(array, f) {
  var v = variance(array, f);
  return v ? Math.sqrt(v) : v;
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-array/src/deviation.js
// module id = ../../../../d3-array/src/deviation.js
// module chunks = 4